import React from 'react';
import PropTypes from 'prop-types';

import CashbackPresenter from '../../../../presenters/CashbackPresenter';

import CashbacksTable from './components/CashbacksTable';

const Cashbacks = (props) => {
  const { cashbacks, loadingState, meta, onPageChange } = props;

  return (
    <div>
      <div className="form-header">
        <h4>Cashbacks</h4>
      </div>
      <CashbacksTable
        cashbacks={cashbacks}
        loadingState={loadingState}
        meta={meta}
        onPageChange={onPageChange}
      />
    </div>
  );
};

export default Cashbacks;

Cashbacks.propTypes = {
  cashbacks: PropTypes.arrayOf(CashbackPresenter.shape()),
  meta: PropTypes.shape().isRequired,
  onPageChange: PropTypes.func.isRequired,
  loadingState: PropTypes.string.isRequired,
};

Cashbacks.defaultProps = {
  cashbacks: [],
};
